import React from 'react';
import Window from '../Browser/Window';

const Haley = () => (
    <Window title="Haley's Window">
        <h1>This is Haley's window!!! She is AWESOME!!!</h1>
    </Window>
);

export default Haley;



// WEBPACK FOOTER //
// ./src/components/windows/Haley.jsx